export const shopTitle = 'Inventory Management'

export const shopCategory = 'Electronics'

export const shopAddress = 'Nagoan Sadar, Naogaon'
export const shopNumber = '+8801689201370, +8801713644570'